import {
  getCellRenderer,
  getCellWidth,
} from "../../../../utils/tableConfigs/OverviewFunctions";

export const AdvancedFiltersColumnConfig = (
  columns: string[],
  lockedColumns: number,
  path: string,
  columnsTitleCreator: (column: string) => React.ReactNode,
  selectionIdentifier: string,
  rowIsSubject = false,
) => {
  return columns.map((column, index) => ({
    title: () => columnsTitleCreator(column),
    dataIndex: column,
    key: column,
    width: getCellWidth(column),
    fixed: index < lockedColumns ? "left" : undefined,
    render: (value: unknown, record: Record<string, unknown>) => {
      return getCellRenderer(
        value,
        column,
        path,
        undefined as any,
        selectionIdentifier,
        rowIsSubject,
        record,
      );
    },
  }));
};
